import styled from 'styled-components';

import { SwitchStyle } from './index';
import { StyleColor, BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface StyledSwitchProps extends BaseStyledComponentProps {
	isActive: boolean;
	style?: SwitchStyle;
}

const Wrapper = styled('div')`
	display: flex;
	align-items: center;
`;

const StyledSwitch = styled('label')`
	box-sizing: border-box;
	position: relative;
	flex: 0 0 auto;
	width: 55px;
	height: 31px;
	border: 2px solid ${({ isActive, style, theme }: StyledSwitchProps) => isActive
		? style && style.activeColor || theme.primary.actionColor
		: 'transparent'
	};
	border-radius: 20px;
	background-color: ${({ isActive, style, theme }: StyledSwitchProps) => isActive
		? style && style.activeColor || theme.primary.actionColor
		: style && style.inactiveColor || hexToRgba(StyleColor.Black, 15)
	};
	transition: all 0.2s ease;
	cursor: pointer;

	&::before {
		content: '';
		box-sizing: border-box;
		position: absolute;
		width: 27px;
		height: 27px;
		border-radius: 50%;
		background-color: ${StyleColor.White};
		transition: transform 0.2s ease;

		${({ isActive }: StyledSwitchProps) => isActive && 'transform: translateX(24px);'}
	}

	input {
		display: none;
	}
`;

export {
	Wrapper,
	StyledSwitch,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/Switch/styles.ts